<template>
  <el-dialog
      title="提案数据EXCEL导入预览窗口"
      :visible.sync="visible"
      width="1200px"
      @close="close">
    <div class="proposalexcel-data">
      <div class="container">
        <!-- <el-form :inline="true" :model="searchParams" class="search-form" method="post" enctype ="multipart/form-data">
          <el-form-item label="Obs ID">
            <el-autocomplete
              class="inline-input"
              v-model="searchParams.obs_id"
              :fetch-suggestions="querySearch"
              :placeholder="`${$t('proposal.obs_id')}`"
              :trigger-on-focus="false"
              @select="handleSelect"
            ></el-autocomplete>
          </el-form-item>
        </el-form> -->
      
        <el-table
          :data="list"
          style="width: 100%;">
          <!-- <el-table-column
            type="selection"
            width="55">
          </el-table-column> -->
          <el-table-column
            prop="id"
            label="ID"
            v-if="false">
          </el-table-column>
          <el-table-column
            fixed
            prop="obs_id"
            label="观测号">        
          </el-table-column>
          <el-table-column
            prop="schedule_id"
            label="计划号">
          </el-table-column>   
          <el-table-column
            prop="tstart"
            label="数据开始时间TT">
          </el-table-column>
          <el-table-column
            prop="tsop"
            label="数据结束时间TT">
          </el-table-column>
          <el-table-column
            prop="start_utc"
            label="数据开始时间UTC">
          </el-table-column>
          <el-table-column
            prop="stop_utc"
            label="数据结束时间UTC">
          </el-table-column>
          <el-table-column
            prop="duration"
            label="数据时长">
          </el-table-column>
          <el-table-column
            prop="pre_slew"
            label="Pre-Slew">
          </el-table-column>
          <el-table-column
            prop="post_slew"
            label="post_slew">
          </el-table-column>
          <el-table-column
            prop="target"
            label="目标">
          </el-table-column>
          <el-table-column
            prop="obs_mode"
            label="观测模式">
          </el-table-column>
          <el-table-column
            prop="data_mode"
            label="数据模式">
          </el-table-column>
          <el-table-column
            prop="proposal"
            label="观测提案">
          </el-table-column>
          <el-table-column
            prop="observer"
            label="观测者">
          </el-table-column>
          <el-table-column
            prop="ptype"
            label="提案类型">
          </el-table-column>
          <el-table-column
            prop="status"
            label="数据状态">
          </el-table-column>
          <el-table-column
            prop="ra"
            label="Ra">
          </el-table-column>
          <el-table-column
            prop="dec"
            label="Dec">
          </el-table-column>
          <el-table-column
            prop="speed"
            label="扫描速度">
          </el-table-column>
          <el-table-column
            prop="interval"
            label="扫描间隔">
          </el-table-column>
          <el-table-column
            prop="radius"
            label="扫描半径">
          </el-table-column>
          <el-table-column
            prop="offset"
            label="偏轴标记">
          </el-table-column>
          <el-table-column
            prop="owner"
            label="权属">
          </el-table-column>
          <el-table-column
            prop="isopen"
            label="公开">
          </el-table-column>
          <el-table-column
            prop="archive_time"
            label="数据归档日期">
          </el-table-column>
          <el-table-column
            prop="release_time"
            label="发布时间">
          </el-table-column>
          <el-table-column
            prop="open_time"
            label="数据公开日期">
          </el-table-column>
          <el-table-column
            prop="l1_file_id"
            label="l1_file_id">
          </el-table-column>
          <el-table-column
            prop="l15_file_id"
            label="l15_file_id">
          </el-table-column>
          <el-table-column
            prop="l2_file_id"
            label="l2_file_id">
          </el-table-column>
          <el-table-column
            prop="create_time"
            label="生成时间">
          </el-table-column>
          <el-table-column
            prop="create_by"
            label="生成者">
          </el-table-column>
          <el-table-column
            prop="update_time"
            label="更新时间">
          </el-table-column>
          <el-table-column
            prop="update_by"
            label="更新者">
          </el-table-column>
          <!-- <el-table-column
            fixed="right"
            width="100"
            label="操作">
            <template slot-scope="scope">
              <el-button
                class="copy-btn"
                :data-clipboard-text="scope.row"
                type="text"
                size="small"
                @click="propExcelEdit(scope.row)">
                编辑
              </el-button>
              <el-button
                class="copy-btn"
                :data-clipboard-text="scope.row.id"
                type="text"
                size="small"
                @click="propDelete(scope.row.id)">
                删除
              </el-button>                   
            </template>
          </el-table-column> -->
        </el-table>

        <!-- <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :current-page.sync="currentPage"
          :page-size.sync="pageSize"
          :total="total"
          @size-change="sizeChange"
          @current-change="changePage">
        </el-pagination> -->
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="ok">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    dialogData: {
      type: Array,
      default(){
        return [];
      },
    },
  },
  data() {
    return {
      searchParams: {
        proposal: '',
        startTime: '',
        endTime: '',
      },
      PropEditForm:{
        id:'', 
        obs_id:'', 
        schedule_id:'', 
        tstart:'',
        tsop:'',
        start_utc:'',
        stop_utc:'',
        duration:'',
        pre_slew:'',
        post_slew:'',
        target:'',
        obs_mode:'',
        data_mode:'',
        proposal:'',
        observer:'',
        ptype:'',
        status:'',
        ra:'', 
        dec:'',
        speed:'',
        interval:'',
        radius:'',
        offset:'',
        owner:'',
        isopen:'', 
        archive_time:'',
        release_time:'',
        open_time:'',
        l1_file_id:'',
        l15_file_id:'',
        l2_file_id:'',
        create_time:'',
        create_by:'',
        update_time:'',
        update_by:'', 
      },
      list:[],
      visible: false,
      currentPage: 1,
      pageSize: 20,
      total: 0,
    };
  },
  watch: {
    dialogVisible(val) {
      // console.log("dialogVisible传入数据在这里",val);
      this.visible = val;
    },
    dialogData(data){
      // console.log("coreedit传入数据在这里",data);
      this.list = data;
      // this.PropEditForm.id = data.id;
      // this.PropEditForm.obs_id = data.obs_id;
      // this.PropEditForm.schedule_id = data.schedule_id;
      // this.PropEditForm.tstart = data.tstart;
      // this.PropEditForm.tsop = data.tsop;
      // this.PropEditForm.start_utc = data.start_utc;
      // this.PropEditForm.stop_utc = data.stop_utc;
      // this.PropEditForm.duration = data.duration;
      // this.PropEditForm.pre_slew = data.pre_slew;
      // this.PropEditForm.post_slew = data.post_slew;
      // this.PropEditForm.target = data.target;
      // this.PropEditForm.obs_mode = data.obs_mode;
      // this.PropEditForm.data_mode = data.data_mode;
      // this.PropEditForm.proposal = data.proposal;
      // this.PropEditForm.observer = data.observer;
      // this.PropEditForm.ptype = data.ptype;
      // this.PropEditForm.status = data.status;
      // this.PropEditForm.ra = data.ra;
      // this.PropEditForm.dec = data.dec;
      // this.PropEditForm.speed = data.speed;
      // this.PropEditForm.interval = data.interval;
      // this.PropEditForm.radius = data.radius;
      // this.PropEditForm.offset = data.offset;
      // this.PropEditForm.owner = data.owner;
      // this.PropEditForm.isopen = data.isopen;
      // this.PropEditForm.archive_time = data.archive_time;
      // this.PropEditForm.release_time = data.release_time;
      // this.PropEditForm.open_time = data.open_time;
      // this.PropEditForm.l1_file_id = data.l1_file_id;
      // this.PropEditForm.l15_file_id = data.l15_file_id;
      // this.PropEditForm.l2_file_id = data.l2_file_id;
      // this.PropEditForm.create_time = data.create_time;
      // this.PropEditForm.create_by = data.create_by;
      // this.PropEditForm.update_time = data.update_time;
      // this.PropEditForm.update_by = data.update_by;      
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    ok() {
      this.$emit('ok', {
        ...this.list,
      });
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
